
// export const BASE_URL = 'http://216.48.182.30:5001/api'
// export const BASE_IMG_URL = 'http://216.48.182.30:5001/'

// export const BASE_URL = 'http://localhost:5001/api'
// export const BASE_IMG_URL = 'http://localhost:5001/'
export const BASE_URL = process.env.REACT_APP_API_URL
export const BASE_IMG_URL = process.env.REACT_APP_API_IMG_URL

console.log("process.env.REACT_APP_API_URL",process.env.REACT_APP_API_URL)
console.log("process.env.REACT_APP_API_IMG_URL",process.env.REACT_APP_API_IMG_URL)

export const currentIp = "216.48.182.30"

export const ACTION_FIRST = 'first'
export const ACTION_PREV = 'prev'
export const ACTION_NEXT = 'next'
export const ACTION_LAST = 'last'

export const PAGE_LIMITS = [25, 50, 100];

export const pumpStatus = {
  0: "Idle",
  1: "Working",
  2: "Not Working",
};

export const productColorInfo = {
  Petrol: "#f3b002",
  Diesel: "#029cf3",
  XP95: "#fb0087",
};



export const permissions = [
  {
    _id: "65167dc1ae5127d1d3f60502",
    moduleId: 1000000000,
    moduleName: "master",
    moduleDisplayName: "Master",
    moduleOrders: 1,
    moduleIcone: "<i class=\"fa fa-sitemap\"></i>",
    firstData: [
      {
        _id: "657add02ca05b720cf76bfd0",
        moduleId: 1010000000,
        moduleName: "company",
        moduleDisplayName: "Company",
        moduleOrders: 1,
        secondData: [
          {
            _id: "657add02ca05b720cf76bfd1",
            moduleId: 1010100000,
            moduleName: "companylisting",
            moduleDisplayName: "Company Listing",
            moduleOrders: 1,
            moduleChecked: true,
            moduleAdd: 'Y',
            moduleView: 'Y',
            thirdData: []
          }
        ]
      },
      {
        _id: "657add02ca05b720cf76bfd2",
        moduleId: 1020000000,
        moduleName: "structure",
        moduleDisplayName: "Structure",
        moduleOrders: 2,
        secondData: [
          {
            _id: "657add02ca05b720cf76bfd3",
            moduleId: 1020100000,
            moduleName: "structurelisting",
            moduleDisplayName: "Structure Listing",
            moduleOrders: 1,
            moduleChecked: true,
            moduleAdd: 'Y',
            moduleView: 'Y',
            thirdData: []
          }
        ]
      },
      {
        _id: "657add02ca05b720cf76bfd4",
        moduleId: 1030000000,
        moduleName: "franchises",
        moduleDisplayName: "Franchises",
        moduleOrders: 3,
        secondData: [
          {
            _id: "657add02ca05b720cf76bfd5",
            moduleId: 1030100000,
            moduleName: "franchiseslisting",
            moduleDisplayName: "Franchises Listing",
            moduleOrders: 1,
            thirdData: []
          }
        ]
      },
      {
        _id: "657add02ca05b720cf76bfd6",
        moduleId: 1040000000,
        moduleName: "usergroups",
        moduleDisplayName: "User Groups",
        moduleOrders: 4,
        secondData: [
          {
            _id: "657add02ca05b720cf76bfd7",
            moduleId: 1040100000,
            moduleName: "usergroupslisting",
            moduleDisplayName: "User Groups Listing",
            moduleOrders: 1,
            moduleChecked: true,
            moduleAdd: 'Y',
            moduleView: 'Y',
            thirdData: []
          }
        ]
      },
      {
        _id: "657add02ca05b720cf76bfd8",
        moduleId: 1050000000,
        moduleName: "templates",
        moduleDisplayName: "Template Master",
        moduleOrders: 5,
        secondData: [
          {
            _id: "657add02ca05b720cf76bfd9",
            moduleId: 1050100000,
            moduleName: "mastertemplatelisting",
            moduleDisplayName: "Master Templates Listing",
            moduleOrders: 1,
            thirdData: []
          },
          {
            _id: "657add02ca05b720cf76bfda",
            moduleId: 1050200000,
            moduleName: "usertemplatelisting",
            moduleDisplayName: "User Templates Listing",
            moduleOrders: 2,
            thirdData: []
          }
        ]
      }
    ]
  },
  {
    _id: "656d7714ac612a0a4e59c329",
    moduleId: 9900000000,
    moduleName: "generalsettings",
    moduleDisplayName: "General Settings",
    moduleOrders: 99,
    moduleIcone: "<i class=\"fa fa-sitemap\"></i>",
    firstData: [
      {
        _id: "657add02ca05b720cf76bfdb",
        moduleId: 9910000000,
        moduleName: "countrystatedistrict",
        moduleDisplayName: "Country, State & District",
        moduleOrders: 1,
        secondData: [
          {
            _id: "657add02ca05b720cf76bfdc",
            moduleId: 9910100000,
            moduleName: "countrylisting",
            moduleDisplayName: "Country Listing",
            moduleOrders: 1,
            moduleChecked: true,
            moduleAdd: 'Y',
            moduleView: 'Y',
            thirdData: []
          },
          {
            _id: "657add02ca05b720cf76bfdd",
            moduleId: 9910200000,
            moduleName: "statelisting",
            moduleDisplayName: "State Listing",
            moduleOrders: 2,
            thirdData: []
          },
          {
            _id: "657add02ca05b720cf76bfde",
            moduleId: 9910300000,
            moduleName: "districtlisting",
            moduleDisplayName: "District Listing",
            moduleOrders: 3,
            thirdData: []
          }
        ]
      },
      {
        _id: "657add02ca05b720cf76bfdf",
        moduleId: 9920000000,
        moduleName: "oilcompany",
        moduleDisplayName: "Oil Company",
        moduleOrders: 2,
        secondData: [
          {
            _id: "657add02ca05b720cf76bfe0",
            moduleId: 9920100000,
            moduleName: "oilcompanylisting",
            moduleDisplayName: "Oil Company Listing",
            moduleOrders: 1,
            moduleChecked: true,
            moduleAdd: 'Y',
            moduleView: 'Y',
            thirdData: []
          }
        ]
      },
      {
        _id: "657add02ca05b720cf76bfe1",
        moduleId: 9930000000,
        moduleName: "product",
        moduleDisplayName: "Product",
        moduleOrders: 3,
        secondData: [
          {
            _id: "657add02ca05b720cf76bfe2",
            moduleId: 9930100000,
            moduleName: "productlisting",
            moduleDisplayName: "Product Listing",
            moduleOrders: 1,
            thirdData: []
          }
        ]
      },
      {
        _id: "657add02ca05b720cf76bfe3",
        moduleId: 9940000000,
        moduleName: "device",
        moduleDisplayName: "Devices",
        moduleOrders: 4,
        secondData: [
          {
            _id: "657add02ca05b720cf76bfe4",
            moduleId: 9940200000,
            moduleName: "devicemasterlisting",
            moduleDisplayName: "Devices Master Listing",
            moduleOrders: 2,
            moduleChecked: true,
            moduleAdd: 'Y',
            moduleView: 'Y',
            thirdData: []
          },
          {
            _id: "657add02ca05b720cf76bfe5",
            moduleId: 9940300000,
            moduleName: "devicemakelisting",
            moduleDisplayName: "Devices Make Listing",
            moduleOrders: 3,
            thirdData: []
          }
        ]
      },
      {
        _id: "657add02ca05b720cf76bfe6",
        moduleId: 9950000000,
        moduleName: "protocol",
        moduleDisplayName: "Protocol",
        moduleOrders: 5,
        secondData: [
          {
            _id: "657add02ca05b720cf76bfe7",
            moduleId: 9950100000,
            moduleName: "protocollisting",
            moduleDisplayName: "Protocol Listing",
            moduleOrders: 1,
            thirdData: []
          }
        ]
      },
      {
        _id: "657add02ca05b720cf76bfe8",
        moduleId: 9960000000,
        moduleName: "baudrate",
        moduleDisplayName: "Baud Rate",
        moduleOrders: 6,
        secondData: [
          {
            _id: "657add02ca05b720cf76bfe9",
            moduleId: 9960100000,
            moduleName: "baudratelisting",
            moduleDisplayName: "Baud Rate Listing",
            moduleOrders: 1,
            thirdData: []
          }
        ]
      }
    ]
  }
];



export const user = [
    {
        "ownLabel": 0,
        "userFor": "",
        "userPumpSetting": 0,
        "userHavePts": "N",
        "companyType": "Comprehensive",
        "_id": "6516662bae5127d1d3f60500",
        "name": "Paramarsh",
        "contactPersonName": "Manoj Kumar",
        "email": "manoj.kumar@fillnow.in",
        "phone": 9711882641,
        "password": "",
        "token": "",
        "image": "",
        "userType": "Admin",
        "address": "C 110 sector 65",
        "state": "Uttar Pradesh",
        "district": "Gautam Buddha Nagar",
        "city": "Noida",
        "pincode": "201301",
        "smsAlert": "Y",
        "emailAlert": "Y",
        "notificationAlert": "Y",
        "lastLoginIp": "",
        "lastLoginDate": null,
        "createdIp": "127.0.0.1",
        "createdDate": "2023-09-29T10:51:04.874Z",
        "updatedIp": "",
        "updatedDate": null,
        "status": "A",
        "updatedAt": "2024-11-29T07:13:19.173Z",
        "haveChild": "N",
        "emailVerify": "Y",
        "phoneVerify": "Y",
        "parentsDetails": []
    }
];
export const paramarshMenu =  [
            {
            "_id": "65167dc1ae5127d1d3f60502",
            "moduleId": 1000000000,
            "moduleName": "master",
            "moduleDisplayName": "Master",
            "moduleOrders": 1,
            "moduleIcone": "<i class=\"fa fa-sitemap\"></i>",
            "firstData": [
                {
                    "_id": "6749698fcf20a66d00f7eb9e",
                    "moduleId": 1010000000,
                    "moduleName": "shiftListing",
                    "moduleDisplayName": "Shift Listing",
                    "moduleOrders": 1,
                    "secondData": [
                        
                    ]
                },
                {
                    "_id": "6749698fcf20a66d00f7eb9e",
                    "moduleId": 1010000000,
                    "moduleName": "domainListing",
                    "moduleDisplayName": "Domain Listing",
                    "moduleOrders": 2,
                    "secondData": [
                        
                    ]
                },
                {
                    "_id": "6749698fcf20a66d00f7eb9e",
                    "moduleId": 1010000000,
                    "moduleName": "degreeListing",
                    "moduleDisplayName": "Degree Listing",
                    "moduleOrders": 3,
                    "secondData": [
                        
                    ]
                },
                {
                    "_id": "6749698fcf20a66d00f7eb9e",
                    "moduleId": 1010000000,
                    "moduleName": "locationListing",
                    "moduleDisplayName": "Location Listing",
                    "moduleOrders": 4,
                    "secondData": [
                        
                    ]
                },
                // {
                //     "_id": "6749698fcf20a66d00f7eb9e",
                //     "moduleId": 1010000000,
                //     "moduleName": "stateDistrictListing",
                //     "moduleDisplayName": "State-District Listing",
                //     "moduleOrders": 5,
                //     "secondData": [
                        
                //     ]
                // },
                
               
               
               
            ]
        },
            {
            "_id": "65167dc1ae5127d1d3f60502",
            "moduleId": 1000000000,
            "moduleName": "user",
            "moduleDisplayName": "User",
            "moduleOrders": 1,
            "moduleIcone": "<i class=\"fa fa-sitemap\"></i>",
            "firstData": [
                {
                    "_id": "6749698fcf20a66d00f7eb9e",
                    "moduleId": 1010000000,
                    "moduleName": "userListing",
                    "moduleDisplayName": "User Listing",
                    "moduleOrders": 1,
                    "secondData": [
                        
                    ]
                },
            ]
        },
        {
            "_id": "65a4c2b303a7564b429be729",
            "moduleId": 8000000000,
            "moduleName": "expert",
            "moduleDisplayName": "Expert",
            "moduleOrders": 80,
            "moduleIcone": "<i class=\"fa fa-sitemap\"></i>",
            "firstData": [
                {
                    "_id": "6749698fcf20a66d00f7eba9",
                    "moduleId": 8010000000,
                    "moduleName": "expertListing",
                    "moduleDisplayName": "Expert Listing",
                    "moduleOrders": 1,
                    "secondData": []
                }
            ]
        },
        {
            "_id": "65a4c2b303a7564b429be729",
            "moduleId": 8000000000,
            "moduleName": "unBlockBookedExp",
            "moduleDisplayName": "Unblock Booked Slot",
            "moduleOrders": 80,
            "moduleIcone": "<i class=\"fa fa-sitemap\"></i>",
            "firstData": [
                
            ]
        },
        {
            "_id": "65a4c2b303a7564b429be729",
            "moduleId": 8000000000,
            "moduleName": "bookedSlot",
            "moduleDisplayName": "Booked Slots",
            "moduleOrders": 80,
            "moduleIcone": "<i class=\"fa fa-sitemap\"></i>",
            "firstData": [
                
            ]
        },
        {
            "_id": "65a4c2b303a7564b429be729",
            "moduleId": 8000000000,
            "moduleName": "locationWiseExpSlots",
            "moduleDisplayName": "Location Wise Expert Slots",
            "moduleOrders": 80,
            "moduleIcone": "<i class=\"fa fa-sitemap\"></i>",
            "firstData": [
                
            ]
        },
        // {
        //     "_id": "65a4c2b303a7564b429be729",
        //     "moduleId": 8000000000,
        //     "moduleName": "myprofile",
        //     "moduleDisplayName": "My Profile",
        //     "moduleOrders": 80,
        //     "moduleIcone": "<i class=\"fa fa-sitemap\"></i>",
        //     "firstData": [
                
        //     ]
        // },
       
       
    ];
export const paramarshUserMenu =  [
        
            {
            "_id": "65167dc1ae5127d1d3f60502",
            "moduleId": 1000000000,
            "moduleName": "bookslot",
            "moduleDisplayName": "Book Slot",
            "moduleOrders": 1,
            "moduleIcone": "<i class=\"fa fa-sitemap\"></i>",
            "firstData": [
                // {
                //     "_id": "6749698fcf20a66d00f7eb9e",
                //     "moduleId": 1010000000,
                //     "moduleName": "userListing",
                //     "moduleDisplayName": "User Listing",
                //     "moduleOrders": 1,
                //     "secondData": [
                        
                //     ]
                // },
            ]
        },
            {
            "_id": "65167dc1ae5127d1d3f60502",
            "moduleId": 1000000000,
            "moduleName": "mybookings",
            "moduleDisplayName": "My Bookings ",
            "moduleOrders": 1,
            "moduleIcone": "<i class=\"fa fa-sitemap\"></i>",
            "firstData": [
                
            ]
        },
            {
            "_id": "65167dc1ae5127e1d3f67502",
            "moduleId": 1000000000,
            "moduleName": "myprofile",
            "moduleDisplayName": "My Profile ",
            "moduleOrders": 1,
            "moduleIcone": "<i class=\"fa fa-sitemap\"></i>",
            "firstData": [
                
            ]
        }
       
       
    ];
export const paramarshExpertMenu =  [
          
            {
            "_id": "65167dc1ae5127d1d3f60502",
            "moduleId": 1000000000,
            "moduleName": "expertavailability",
            "moduleDisplayName": "Expert Availability",
            "moduleOrders": 1,
            "moduleIcone": "<i class=\"fa fa-sitemap\"></i>",
            "firstData": [
                // {
                //     "_id": "6749698fcf20a66d00f7eb9e",
                //     "moduleId": 1010000000,
                //     "moduleName": "userListing",
                //     "moduleDisplayName": "User Listing",
                //     "moduleOrders": 1,
                //     "secondData": [
                        
                //     ]
                // },
               
               
               
            ]
        },
            {
            "_id": "65167dc1ae5127d1d3f60502",
            "moduleId": 1000000000,
            "moduleName": "bookedslots",
            "moduleDisplayName": "Booked Slots",
            "moduleOrders": 1,
            "moduleIcone": "<i class=\"fa fa-sitemap\"></i>",
            "firstData": [
                // {
                //     "_id": "6749698fcf20a66d00f7eb9e",
                //     "moduleId": 1010000000,
                //     "moduleName": "userListing",
                //     "moduleDisplayName": "User Listing",
                //     "moduleOrders": 1,
                //     "secondData": [
                        
                //     ]
                // },
               
               
               
            ]
        },
        {
          "_id": "65167dc1ae5127e1d3f67502",
          "moduleId": 1000000000,
          "moduleName": "myexpertprofile",
          "moduleDisplayName": "My Profile ",
          "moduleOrders": 1,
          "moduleIcone": "<i class=\"fa fa-sitemap\"></i>",
          "firstData": [
              
          ]
      }
       
       
       
    ];


export const authorizedRoutes = [
        
            {
                "menu": "User Listing",
                "path": "/user/userListing"
            },
            {
                "menu": "Company Listing AddData",
                "path": "/master/company/companylisting/add"
            },
            {
                "menu": "Company Listing AddData",
                "path": "/master/company/companylisting/manageautomationequipment/add/:id/:id2"
            },
            {
                "menu": "Company Listing AddData",
                "path": "/master/company/companylisting/manageautomationequipment/add/:id/:id2"
            },
           
           
           
           
    ];

    export const SESSION_DATA = [
        {
            "SDRISHTI_USER_LOGGED_IN": true,
            "SDRISHTI_USER_OILCOMPANY_ID": null,
            "SDRISHTI_USER_OILCOMPANY_NAME": null,
            "SDRISHTI_USER_COUNTRY_ID": null,
            "SDRISHTI_USER_COUNTRY_NAME": null,
            "SDRISHTI_USER_STATE_ID": null,
            "SDRISHTI_USER_STATE_NAME": null,
            "SDRISHTI_USER_DISTRICT_ID": null,
            "SDRISHTI_USER_DISTRICT_NAME": null,
            "SDRISHTI_USER_ID": "6516662bae5127d1d3f60500",
            "SDRISHTI_USER_NAME": "Synergy Drishti",
            "SDRISHTI_USER_CONTACT_NAME": "Manoj Kumar",
            "SDRISHTI_USER_EMAIL": "arvind.chaudhary@fillnow.in",
            "SDRISHTI_USER_MOBILE": 9711882641,
            "SDRISHTI_USER_IMAGE": "",
            "SDRISHTI_USER_USER_TYPE": "Super User",
            "SDRISHTI_USER_PARENT_DETAILS": "",
            "SDRISHTI_USER_OWN_LABEL": 0,
            "SDRISHTI_USER_SMS_ALERT": "Y",
            "SDRISHTI_USER_EMAIL_ALERT": "Y",
            "SDRISHTI_USER_NOTIFICATION_ALERT": "Y",
            "SDRISHTI_USER_CURRENT_PATH": "",
            "SDRISHTI_USER_LAST_LOGIN": "null ()",
            "SDRISHTI_USER_LOGIN_TOKEN": "",
            "SDRISHTI_USER_POSITION_CURRENT_ID": null,
            "SDRISHTI_USER_POSITION_ID": null,
            "SDRISHTI_USER_POSITION_NAME": null,
            "SDRISHTI_USER_POSITION_CONTACT_NAME": null,
            "SDRISHTI_USER_POSITION_EMAIL": null,
            "SDRISHTI_USER_POSITION_LABEL": null,
            "SDRISHTI_USER_POSITION_LABEL_NAME": null,
            "SDRISHTI_USER_POSITION_STATUS": null,
            "SDRISHTI_USER_POSITION_START_DATE": null,
            "SDRISHTI_USER_SALT": "$2a$10$NObtf2bsKq2cW40gIbgDjO",
            "SDRISHTI_USER_ENCRYPT_PASSWORD": "$2a$10$NObtf2bsKq2cW40gIbgDjOlufuhD7Nqy6Xq5W9rAotI3XLyqJKIfG"
        }
      ];
      export const modulePermissions = 
        {
          "canAdd": true,
          "canEdit": true,
          "canDelete": true,  
          "canDownload": true
      };
      
